<style>
    .loader-wrapper {
        width: 100vw;
        height: 100vh;
        background: #0a0a0a;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loader {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
    }

    .spinner {
        width: 48px;
        height: 48px;
        border: 3px solid rgba(255, 255, 255, 0.1);
        border-top-color: #4facfe;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .loader-text {
        color: rgba(255, 255, 255, 0.5);
        font-size: 0.9rem;
        font-family: "Roboto", "Inter", Arial, Helvetica, sans-serif;
        letter-spacing: 0.05em;
    }
</style>

<div class="loader-wrapper">
    <div class="loader">
        <div class="spinner"></div>
        <div class="loader-text">Loading map data...</div>
    </div>
</div>
